module.exports = __webpack_public_path__ + "static/media/img_1.96456567.png";